import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export interface IWinClusterData {
    amount: number;
    length: number;
    mode: string;
    multipliedAmount: number;
    multiplier: number;
    reelWinPositions: boolean[][];
    symbol: string;
    wildMultiplier: number;
}

export interface IFeaturePosition {
    reelId: number;
    symId: number;
    symName: string;
}

export interface IInfectedPosition extends IFeaturePosition {
    angle: number;
}

export interface INeighboursData {
    origin: IFeaturePosition;
    infectedPositions: IInfectedPosition[];
}

export enum DjPsychoWinTypes {
    TINY = "tiny",
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large",
    BIG_WIN_01 = "bigWin01",
    BIG_WIN_02 = "bigWin02",
    BIG_WIN_03 = "bigWin03",
    BIG_WIN_04 = "bigWin04",
    BIG_WIN_05 = "bigWin05"
}

export interface IWinRatioConfig {
    readonly ratio: number;
    readonly duration: number;
    readonly type: string;
}

export interface IWinRatios {
    readonly normalWin: IWinRatioConfig[];
    readonly bigWin: IBigWinLevel[];
}

export interface IBigWinLevel extends IWinRatioConfig {
    readonly from: number;
    to: number;
    readonly id: number;
}

export interface ISymbolValues {
    [symbolName: string]: { [numSymbols: number]: number };
}

export interface IDjPsychoData {
    mode: string;
    nextMode: string;
    reels: string[][];
    evaluatedArea: string[][];
    evaluatedArea2: string[][];
    freespinsLeft: number;
    accumulatedRoundWin: number;
    playedBetValue: number;
    activeColorsForFS: boolean[];
    colorMultsAfterCollapse: number[];
    freespinTriggeredThisSpin: boolean; // game is not using it, however action spins will use it.
    wasFeatureBuy: boolean;
    currentMultiplier: number;
}

export interface IDjPsychoInitData extends IDjPsychoData {
    isRestoreState: boolean;
    featureBuyTimesBetValue: FeatureBuyTimesBetValue[];
    reelsAfterCollapse: string[][];
    allSize: number[][];
    symbolValues: ISymbolValues;
    nextPlayerInteraction: any;
    secondReels: string[][];
    enhancedBet: boolean;
}

export interface IDjPsychoGameData extends IDjPsychoData {
    betClusterWins: IWinClusterData[];
    accumulatedRoundWin: number;
    totalSpinWinnings: number;
    freespinsLeft: number;
    playedBetValue: number;
    brokeBank: boolean;
    totalSpinRoundWinnings: number;
    listOfMergePositions: number[];
    positionForExtraFeature: number;
    numberOfFreespinsPlayed: number;
}